export default class DettagliUtente{

    DatiUtente;
    DatiAzienda;

    constructor(){}
}